module.exports = __webpack_public_path__ + "img/Header.0118ab78.png";